<template>
<div
    class="test-question-card"
    :class="{ 'edit-mode': isEditMode }"
>
    <div class="test-question-card-header" @click="toggleEditMode">
        <div class="test-question-card-text">
            <div class="question-number">
                {{ rowNumber }}
            </div>
            <span class="question-header-text" :title="text">
                {{ text }}
            </span>
        </div>
        <div class="ml-auto test-question-card-buttons">
            <div class="test-question-edit-button icon" @click.stop="toggleEditMode">
                <svg>
                    <use xlink:href="#icon-pencil"></use>
                </svg>
            </div>
            <div v-if="isCanEdit" class="test-question-delete-button icon" @click.stop="deleteQuestionHandler">
                <svg>
                    <use xlink:href="#icon-cross"></use>
                </svg>
            </div>
        </div>
    </div>
    <question-edit-form
        :question="question"
        v-if="isEditMode"
    />
</div>
</template>

<script>
import QuestionEditForm from "./QuestionEditForm";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "QuestionListCard",
    components: {QuestionEditForm},
    props: {
        question: Object,
        rowNumber: Number,
    },
    computed: {
        ...mapGetters('tests', [
            'trans',
            'testBeingEdited',
            'isCanEdit',
        ]),
        isEditMode() {
            return this.testBeingEdited.questions[this.question.hash_id].isEditing ?? false;
        },
        text() {
            if (!this.question.text || this.question.text === "") {
                return this.trans.edit_form.question_tabs.empty_question_label;
            }

            return this.question.text.replace(/(?:&nbsp;)|(<([^>]+)>)/gi, "");
        },
        iconClass() {
            let iconMap = {
                number_input: 'fas fa-i-cursor',
                text_input: 'fas fa-i-cursor',
                single_choice: 'fa fa-check-circle',
                multiple_choice: 'fas fa-tasks',
            };

            return iconMap[this.question.type];
        },
    },
    methods: {
        ...mapActions('tests', [
            'setQuestionBeingEdited',
            'deleteQuestion',
            'showDeleteConfirmationModal',
            'hideConfirmationModal',
        ]),
        toggleEditMode() {
            this.setQuestionBeingEdited({
                questionId: this.question.hash_id,
                isBeingEdited: !this.isEditMode,
            });
        },
        deleteQuestionHandler() {
            let maxLength = 50,
                modalText = this.text.substring(0,maxLength);

            modalText += this.text.length > maxLength ? '...' : '';

            this.showDeleteConfirmationModal({
                text: this.replaceWildcards(this.trans.edit_form.modals.delete_question_text, {
                    question_name: modalText,
                }),
                confirmationHandler: this.deleteCurrentQuestion,
                cancelHandler: this.hideConfirmationModal,
            })
        },
        deleteCurrentQuestion() {
            this.deleteQuestion(this.question);
            this.hideConfirmationModal();
        }
    }
}
</script>

<style scoped lang="scss">
@import 'resources/sass/variables';
.test-question-card {
    height: 100%;
    border: 1px solid $tests-light-grey;
    border-radius: 6px;
    font-size: 1rem;
    font-weight: 600;
    display: flex;
    flex-direction: column;
    padding: 0 8px 0 16px;

    &:hover:not(.edit-mode) {
        border-color: $tests-blue;
        box-shadow: 0 0 9px rgba(131, 131, 131, 0.2);
        cursor: pointer;
        color: $tests-blue;
    }

    * {
        align-items: center;
        display: flex;
    }
}

.test-question-card-header {
    height: 55px;
    cursor: pointer;
}

.test-question-card-text {
    overflow: hidden;

    .question-header-text {
        display: block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}

.question-number {
    color: $grey;
    min-width: 22px;
    display: inline-flex;
    margin-right: 10px;
    justify-content: center;
}

.test-question-card-buttons {
    justify-content: center;
}

.icon {
    color: $grey;
    fill: $grey;
    padding: 0 10px;
    width: 100%;
    height: 100%;

    svg {
        width: 20px;
        height: 20px;
    }

    &.test-question-edit-button {
        .edit-mode &,
        &:hover {
            color: $tests-blue;
            fill: $tests-blue;
            cursor: pointer;
        }
    }

    &.test-question-delete-button:hover {
        color: $tests-red;
        fill: $tests-red;
        cursor: pointer;
    }
}
</style>
